import comp from "./AssignClassSettingsDataGridWrapper";
export default comp;
